import React from "react";
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskAccountBrokerage(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;


  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      onChange={onChange}
      maskChar=""
      mask="# ************"
      formatChars={{"*": "[0-9]*"}}
    />
  );
}

InputMaskAccountBrokerage.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskAccountBrokerage.js